import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PACIFailed from "../../assets/img/PACIFailed.svg";
import Spinner from '../../views/shared/spinner.component';
import StorefrontTitle from '../shared/storefront-title.component';


const subscriptions = [];
const PaciFailure = (props) => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [loading, setLoading] = useState(false);
    useEffect(() => {

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const retryHandling = () => {
        setLoading(true);
        props.setPaciResponse(null);
        props.fetchTimerValue();
        props.checkPaciConnection();
        props.updateTimer();
        setLoading(false);
    }

    const skipHandling = () => {
        props.history.push("/scan/id")
    }

    return (
        <div className="paci paci-result">
            <img src={PACIFailed} alt="" />
            <StorefrontTitle 
                title={"Your ID has not been verified."}
                desc={"Please try again later"}
            />
            {loading ? <Spinner /> :
                <div className="two-common-btn-container">
                    <button
                        className="common-button" 
                        onClick={retryHandling}
                    >
                        Try again
                    </button>
                    <button
                        className="common-button-light" 
                        onClick={skipHandling}
                    >
                        {translationKeys["ob_paci_failure_skip"]}
                    </button>
                </div>}
        </div>
    )
}

export default PaciFailure;